import React from 'react';
import { Link } from 'react-router-dom';
import { getWeightTypeLabel } from '../utils/inventoryPrint';

export interface WarehouseTransferAvailabilityData {
  date: string;
  sourceWarehouseId: number;
  destinationWarehouseId: number;
  recipeSummary: string;
  items: Array<{
    productId: number; productName: string; weightType: string;
    quantity: number; availableQuantity: number; shortage: number;
  }>;
}

export default function WarehouseTransferAvailability({
  data, transferId,
}: { data: WarehouseTransferAvailabilityData; transferId?: number }) {
  return <section aria-label="Інгредієнти та нестача">
    {data.recipeSummary && <p>{data.recipeSummary}</p>}
    <ul>
      {data.items.map(item => <li key={item.productId}>
        <strong>{item.productName}</strong>: потрібно {item.quantity.toFixed(3)} {getWeightTypeLabel(item.weightType)},
        {' '}наявно {item.availableQuantity.toFixed(3)}
        {item.shortage > 0 && <>
          {' '}· <strong>Не вистачає: {item.shortage.toFixed(3)} {getWeightTypeLabel(item.weightType)}</strong>
          {transferId && <p><Link className="crm-position-insert__button" style={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, overflowWrap: 'anywhere' }}
            to={`/management/inventory-receipts?warehouseTransferId=${transferId}&productId=${item.productId}`}>
            Додати продукт на склад: {item.productName}
          </Link></p>}
        </>}
      </li>)}
    </ul>
    {data.items.some(item => item.shortage > 0) && <p>
      {transferId
        ? 'Кнопка відкриває нову накладну з продуктом, кількістю нестачі та складом відправлення. Перевірте фактичний прихід, дату, ціну й документ; збережіть і проведіть накладну. Поверніться сюди, оновіть нестачу та окремо проведіть переміщення.'
        : 'Збережіть переміщення як непроведене — в його історії з’явиться кнопка «Додати продукт на склад» для кожного відсутнього інгредієнта.'}
      {' '}Сам перехід не додає запас; прихід пізніше дати переміщення його не покриває.
    </p>}
  </section>;
}
